import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Checklist } from '../../../classes/checklist';
import { ChecklistService } from '../../../services/checklist';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-checklist-update',
  templateUrl: './checklist-update.component.html',
  styleUrls: ['./checklist-update.component.css']
})
export class ChecklistUpdateComponent implements OnInit {
  checklist!: Checklist;
  checklistUpdateResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private checklistService: ChecklistService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.checklistService.getByID(params.get('id'))
        .subscribe({
          next: (checklist: any) => {
            this.checklist = checklist;
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
          }
        });
    });
  }

  onSubmit() {
    this.checklistService.update(this.checklist)
      .subscribe({
        next: () => {
          this.router.navigate(['/checklist']);
        },
        error: (err: HttpErrorResponse) => {
          this.checklistUpdateResult = false;
          console.log(err);
        }
      });
  }

}
